module.exports = __webpack_public_path__ + "img/2.76577345.jpg";